import { uiTypeIs, rankWith } from '@jsonforms/core'
import { CSV_READER_RENDERER_META } from './CsvReaderControl'

export default rankWith(
  5, // increase rank as needed
  uiTypeIs(CSV_READER_RENDERER_META.type)
)
